exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-comment {\n  z-index: 100;\n  position: absolute;\n  word-break: break-word;\n  background: #fff;\n  left: 2rem;\n  top: 1rem;\n  max-width: 40rem;\n  border-radius: 14px;\n  border: 1px solid #333;\n  font-size: 18px;\n  line-height: 26px;\n  padding: 8px 10px 10px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n", ""]);

// exports
